import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3671e966")

_pushScopeId("data-v-3671e966")
const _hoisted_1 = { class: "ui__configInfo_main" }
const _hoisted_2 = { class: "ui__configInfo_body" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "ui__configInfo_title" }, "配置信息", -1)
const _hoisted_4 = { class: "ui__configInfo_content" }
const _hoisted_5 = { class: "ui_config_content_item_label" }
const _hoisted_6 = { class: "ui_config_content_item_value" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.dataList, (item) => {
          return (_openBlock(), _createBlock("div", {
            class: "ui_config_content_item",
            key: item.name
          }, [
            _createVNode("div", _hoisted_5, _toDisplayString(item.fieldName), 1),
            _createVNode("div", _hoisted_6, [
              (item.fieldValue)
                ? (_openBlock(), _createBlock("span", _hoisted_7, _toDisplayString(item.fieldValue), 1))
                : (_openBlock(), _createBlock("span", _hoisted_8, "-"))
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
})